// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "webpack/css/" + "styles" + "." + "9cf25012f01516cd3188" + ".css";
};